import React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import TabBar from '../../components/TabBar';
import { useChat } from '../../contexts/ChatContext';
import { COLORS } from '../../theme/themeTokens';
import SupportHeader from './SupportHeader';

interface Props {
  onPersonal: () => void;
  onClients: () => void;
  onNavigate: (screen: string) => void;
}

const formatUnreadCount = (count: number) => count > 99 ? '99+' : String(count);

const ChoiceRow = ({
  label,
  icon,
  unreadCount,
  onPress,
}: {
  label: string;
  icon: any;
  unreadCount: number;
  onPress: () => void;
}) => (
  <TouchableOpacity
    style={styles.row}
    onPress={onPress}
    activeOpacity={0.7}
    accessibilityLabel={unreadCount > 0 ? `${label}, ${formatUnreadCount(unreadCount)} unread` : label}
  >
    <View style={styles.iconBox}>
      <Image source={icon} style={styles.icon} resizeMode="contain" />
      {unreadCount > 0 && (
        <View style={styles.badge}>
          <Text style={styles.badgeText}>{formatUnreadCount(unreadCount)}</Text>
        </View>
      )}
    </View>
    <Text style={styles.label}>{label}</Text>
    <Image source={require('../../assets/arrow.png')} style={styles.arrow} resizeMode="contain" />
  </TouchableOpacity>
);

const SupportChooserScreen: React.FC<Props> = ({ onPersonal, onClients, onNavigate }) => {
  const { unreadCount, clientSupportUnreadCount } = useChat();

  return (
    <View style={styles.container}>
      <SupportHeader />
      <View style={styles.card}>
        <ChoiceRow
          label="Personal support"
          icon={require('../../assets/support.png')}
          unreadCount={unreadCount}
          onPress={onPersonal}
        />
        <View style={styles.divider} />
        <ChoiceRow
          label="Client support"
          icon={require('../../assets/dashboard-header-person.png')}
          unreadCount={clientSupportUnreadCount}
          onPress={onClients}
        />
      </View>
      <TabBar activeTab="support" onNavigate={onNavigate} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: COLORS.pureLight },
  card: {
    margin: 12,
    backgroundColor: COLORS.white,
    borderWidth: 1,
    borderColor: COLORS.softGrey,
    borderRadius: 12,
    overflow: 'hidden',
  },
  row: { height: 64, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 12 },
  divider: { height: 1, backgroundColor: COLORS.softGrey, marginLeft: 54 },
  iconBox: {
    width: 38,
    height: 38,
    borderRadius: 8,
    backgroundColor: COLORS.pureLight,
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: { width: 22, height: 22, tintColor: COLORS.primaryNavy },
  badge: {
    position: 'absolute',
    top: -7,
    right: -8,
    minWidth: 18,
    height: 18,
    borderRadius: 9,
    paddingHorizontal: 4,
    backgroundColor: '#E53935',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeText: { color: COLORS.white, fontSize: 10, fontWeight: '600' },
  label: { flex: 1, marginLeft: 12, color: COLORS.primaryNavy, fontSize: 15 },
  arrow: { width: 13, height: 13, tintColor: COLORS.blueSteel, transform: [{ rotate: '180deg' }] },
});

export default SupportChooserScreen;
